import { SearchReportsParams } from '@mobileTypes'

import {
  useArchiveMobileReportsMutation,
  useFetchMobileReportByIdQuery,
  useFetchMobileReportsQuery,
  useRestoreMobileReportsMutation,
} from '../services'

export const useMobileReports = (params: SearchReportsParams) => {
  const { data, isLoading, isFetching, isError, refetch } = useFetchMobileReportsQuery(params)

  return {
    items: data?.items ?? [],
    total: data?.total ?? 0,
    ttlDays: data?.ttlDays,
    loading: isLoading || isFetching,
    isError,
    refetch,
  }
}

export const useMobileReport = (incidentId?: string, archived = false) => {
  const { data, isLoading, isError, isFetching } = useFetchMobileReportByIdQuery(
    { incidentId: incidentId ?? '', archived },
    {
      skip: !incidentId,
    }
  )

  return {
    report: data,
    loading: isLoading || isFetching,
    isError,
  }
}

export const useArchiveMobileReports = () => useArchiveMobileReportsMutation()
export const useRestoreMobileReports = () => useRestoreMobileReportsMutation()
